import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Flame, Menu } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger, SheetTitle } from "@/components/ui/sheet";

const LINKS = [
  { to: "/genera", label: "Generatore", id: "generator" },
  { to: "/verifica", label: "Verifica idea", id: "validate" },
  { to: "/idee-del-giorno", label: "Idee del giorno", id: "daily" },
  { to: "/classifica", label: "Classifica", id: "leaderboard" },
  { to: "/le-mie-idee", label: "Le mie idee", id: "my-ideas" },
  { to: "/pro", label: "Piano Pro", id: "pro" },
];

const linkCls = ({ isActive }) =>
  `text-sm font-medium transition-colors duration-200 ${isActive ? "text-amber-400" : "text-slate-400 hover:text-slate-100"}`;

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  return (
    <nav className="sticky top-0 z-50 backdrop-blur-xl bg-[#090A0F]/80 border-b border-white/5" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 group" data-testid="nav-logo">
          <span className="w-8 h-8 rounded-lg bg-amber-500 grid place-items-center shadow-[0_0_20px_rgba(245,158,11,0.4)] transition-transform duration-300 group-hover:rotate-12">
            <Flame className="w-4 h-4 text-slate-950" strokeWidth={2.5} />
          </span>
          <span className="font-display text-lg font-bold tracking-tight">IdeaForge</span>
        </Link>
        <div className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <NavLink key={l.to} to={l.to} className={linkCls} data-testid={`nav-link-${l.id}`}>
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/genera"
            data-testid="nav-cta-generate"
            className="rounded-full bg-amber-500 px-5 py-2 text-sm font-semibold text-slate-950 transition-colors duration-200 hover:bg-amber-400"
          >
            Genera idee
          </Link>
        </div>
        <Sheet open={open} onOpenChange={setOpen}>
          <SheetTrigger className="md:hidden p-2 text-slate-300" data-testid="nav-mobile-menu-btn">
            <Menu className="w-5 h-5" />
          </SheetTrigger>
          <SheetContent side="right" className="bg-[#0d0f17] border-white/10">
            <SheetTitle className="font-display text-left">IdeaForge</SheetTitle>
            <div className="flex flex-col gap-5 mt-8">
              {LINKS.map((l) => (
                <NavLink key={l.to} to={l.to} className={linkCls} onClick={() => setOpen(false)} data-testid={`nav-mobile-link-${l.id}`}>
                  {l.label}
                </NavLink>
              ))}
            </div>
          </SheetContent>
        </Sheet>
      </div>
    </nav>
  );
};
